export const AUTH_ERROR_MESSAGES: Record<string, string> = {
  invalid_grant: 'The code you entered is incorrect.',
  too_many_attempts:
    "Your account has been blocked after multiple consecutive login attempts. We've sent you a notification via your preferred contact method with instructions on how to unblock it.",
  unknown_error: 'An unknown error occurred. Please try again later.',
};
